// - Inspired by pope. Modified to support custom `regex` option. https://github.com/poppinss/pope/pull/4
// - Extended to support expressions
function isObj(obj) {
    return obj !== null && typeof obj === "object";
}
export function prop(obj, path, def = undefined) {
    return path
        .split(" ")
        .map(word => propWord(obj, word, def))
        .join(" ");
}
/**
 * @param obj -> object containing all the admission answers
 * @param path -> path of an admission answer or a plain string
 * @param def - default value if path is accessing answers from the admission
 *              and the answer is not found
 * @returns {string | undefined}
 */
function propWord(obj, path, def) {
    if (!isObj(obj) || typeof path !== "string") {
        return obj;
    }
    const pathArr = path.split(/\.\b/g);
    if (pathArr.length === 1) {
        return path;
    }
    for (let i = 0; i < pathArr.length; i++) {
        const p = pathArr[i];
        obj = Object.prototype.hasOwnProperty.call(obj, p) ? obj[p] : null;
        if (obj === null) {
            break;
        }
    }
    return obj !== null ? obj : def;
}
function isExpression(item) {
    return item.startsWith("IF");
}
function parseExpression(item) {
    const [rawCondition, body] = item.split("THEN");
    const [truthy, falsy] = body.split("ELSE").map(val => val.trim());
    const condition = rawCondition.replace("IF", "").trim();
    return { condition: condition, truthy: truthy, falsy: falsy };
}
export function evaluateExpression(data, { condition, truthy, falsy }) {
    if (condition.includes(" = ")) {
        const [left, right] = condition.split("=").map(val => val.trim());
        const propLeft = String(prop(data, left, left));
        const propRight = String(prop(data, right, right));
        return propLeft === propRight
            ? // First, try to find value in data, if not send back literal from incoming string
                prop(data, truthy, truthy)
            : // First, try to find value in data, if not send back literal from incoming string
                prop(data, falsy, falsy);
    }
    else {
        // workaround for conditions testing presence of a value
        return prop(data, condition, null)
            ? prop(data, truthy, truthy)
            : prop(data, falsy, falsy);
    }
}
export function parse(string, data, options, defaultValue = "") {
    options = {
        skipUndefined: false,
        throwOnUndefined: false,
        regex: /{{2}(.+?)}{2}/g,
        ...options,
    };
    const regex = options.regex;
    let result;
    let formattedString = string;
    while ((result = regex.exec(string)) !== null) {
        const item = result[1].trim();
        if (item) {
            let value;
            if (isExpression(item)) {
                const expression = parseExpression(item);
                value = evaluateExpression(data, expression);
            }
            else {
                const nextValue = prop(data, item, defaultValue);
                value =
                    defaultValue !== "" && nextValue === "" ? defaultValue : nextValue;
            }
            if (value !== undefined && value !== null) {
                formattedString = formattedString.replace(result[0], value);
            }
            else if (options.throwOnUndefined) {
                const error = new Error("Missing value for " + result[0]);
                error.key = item;
                error.code = "E_MISSING_KEY";
                throw error;
            }
            else if (!options.skipUndefined) {
                formattedString = formattedString.replace(result[0], "");
            }
        }
    }
    return formattedString;
}
